export default "__VITE_ASSET__B86PK4Qs__"